module.exports = __webpack_public_path__ + "img/yellows.770efed.png";